module.exports = __webpack_public_path__ + "img/08_bg.514bb771.jpg";